import { pathgen } from 'object-path-generator';
import { useMutationState } from "../../../hooks/reactQuery/useMutationState";
import { useStoreActions } from "../../../store/store-context";
export const useUnarchiveDraftTestIds = pathgen('useUnarchiveDraftTestIds');
export const useUnarchiveDraft = _ref => {
  let {
    onSuccess,
    biCode
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    mutate,
    isLoading
  } = useMutationState({
    mutationFn: draftId => api.draft.unarchive(draftId),
    biCode,
    toasts: {
      successMessage: 'Draft unarchived successfully',
      successTestId: useUnarchiveDraftTestIds.SuccessToast(),
      errorMessage: 'Failed to unarchive draft',
      errorTestId: useUnarchiveDraftTestIds.ErrorToast()
    },
    onSuccess
  });
  return {
    unarchiveDraft: mutate,
    isLoading
  };
};